* {
  box-sizing: border-box;
}

#security-server-status {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 3);
}

.loading-container {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 5);
  width: 100%;

  .loading-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: calc(var(--spacer) * 9);

    gz-loader {
      height: fit-content;
    }
  }

  .loading-section {
    display: flex;
    flex-direction: column;
    gap: var(--spacer);
    width: 100%;
  }
}

.loading-header,
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: calc(var(--spacer) * 9);
  width: 100%;
  padding: var(--spacer) 0;

  .vertical-bar {
    background-color: var(--chart-101-pressed-dividers);
    width: 1px;
    height: 100%;
    margin: calc(var(--spacer) * 2);
  }

  gz-widget-header-item {
    flex: 1;
  }
}

gz-info-box {
  --info-box-width: 100%;
  --info-box-message-width: calc(100% - var(--spacer) * 7);
}
